ApiAjax = require 'app/scripts/network/api-ajax'
BillingFormUtil = require './internal/billing-form-util'
CreditCardFormError = require './internal/credit-card-form-error'
Promise = require 'bluebird'
React = require 'react'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
f = require 'effing'
l = require 'app/scripts/lib/localize'
submitCreditCard = require './internal/submit-credit-card'
t = require('app/scripts/views/internal/recup-with-helpers')('credit_card')
{ track } = require '@trello/analytics'
xtend = require 'xtend'

CreditCardComponent = require './form-sections/credit-card-component'
AddressTaxComponent = require './form-sections/address-tax-component'
SummaryComponent = require './form-sections/summary-component'
FreeTrialSummaryComponent = require './form-sections/free-trial-summary-component'
TermsOfServiceComponent = require './form-sections/terms-of-service-component'
ProductsComponent = require './form-sections/products-component'
{ PurchaseFormIds } = require '@trello/webdriverio-tests'

module.exports = class extends React.Component
  displayName: 'CreditCardFormComponent'
  zeroAmount: '0.00'

  constructor: (props) ->
    super(props)

    @state = {
      errorField: null
      unknownError: null
      waitingForCCAuth: false
      tax: @zeroAmount
      country: 'US'
      region: ''
      zipCode: ''
      taxId: ''
      selectedBillingPlan: @props.yearlyProduct?.productNumber
    }

    @calculateSalesTaxDebounced = _.debounce(@calculateSalesTax, 750)

  componentDidMount: ->
    @isStillMounted = true

  getData: =>
    @props.extraData

  setBillingPlan: (plan) =>
    if (plan == @state.selectedBillingPlan)
      return
    @setState
      selectedBillingPlan: plan,
      ->
        if @state.zipCode != ''
          @calculateSalesTax(@state)

  resetSalesTax: =>
    @setState
      tax: @zeroAmount
      region: ''
      zipCode: ''
      taxId: '',

  calculateSubTotalCost: =>
    switch @state.selectedBillingPlan.toString()
      when @props.yearlyProduct.productNumber.toString()
        @props.yearlyProduct.totalPrice || @props.yearlyProduct.price
      when @props.monthlyProduct.productNumber.toString()
        @props.monthlyProduct.totalPrice || @props.monthlyProduct.price

  calculateInvitedUsersSubTotal: =>
    if @props.invitedUsersCount
      switch @state.selectedBillingPlan.toString()
        when @props.yearlyProduct.productNumber.toString()
          @props.yearlyProduct.price * @props.invitedUsersCount
        when @props.monthlyProduct.productNumber.toString()
          @props.monthlyProduct.price * @props.invitedUsersCount
    else
      0

  calculateSalesTax: ({ country, zipCode, taxId }) =>
    @setState
      country: (if country then country else @state.country)
      zipCode: (if zipCode then zipCode else '')
      taxId: (if taxId then taxId else '')
      ->
        url = "/1/members/me/paidAccount/salesTax?country=#{ @state.country }&subtotal=#{ @calculateSubTotalCost() }"

        if @state.zipCode.length
          url += "&postalCode=#{ @state.zipCode }"

        if @state.taxId.length
          url += "&taxId=#{ @state.taxId }"

        ApiAjax
          url: url
          type: 'GET'
          success: (data) =>
            @setState
              tax: data.tax
              region: data.taxRegion
              errorField: null
          error: (xhr) =>
            field = BillingFormUtil.getErrorField(xhr?.responseJSON?.error)
            @setState
              tax: null
              region: null
              errorField: field

  render: t.renderable ->
    {
      buttonKey,
      buttonText,
      productName,
      yearlyProduct,
      monthlyProduct,
      defaultProduct,
      billingStrategy,
      invitedUsersCount,
      isMoonshotBilling,
      isFreeTrial
      creditCardFormTitle
    } = @props
    { errorField, unknownError, waitingForCCAuth, tax, region, selectedBillingPlan, country } = @state
    childRefs = []

    onClick = =>
      dataPromise = Promise.map(childRefs, (childRef) ->
        if childRef then childRef.formFieldsRef.getData() else {}
      )
      .then (dataList) =>
        dataList.concat([@getData()])
      .then (dataList) ->
        xtend dataList...

      @submit dataPromise
      return

    onKeyDown = (e) =>
      if e.key == 'Enter'
        onClick()

    t.div '.credit-card-form.billing-inner.bc-billing-wrap', {
      onKeyDown: onKeyDown
    }, =>
      t.createElement ProductsComponent, {
        productName: productName
        monthlyProduct: monthlyProduct
        yearlyProduct: yearlyProduct
        defaultProduct: defaultProduct
        billingStrategy: billingStrategy
        isFreeTrial
        @setBillingPlan
        selectedBillingPlan
        ref: f(childRefs, 'push')
      }
      t.createElement CreditCardComponent, {
        title: creditCardFormTitle
        ref: f(childRefs, 'push')
      }
      t.createElement AddressTaxComponent, {
        @calculateSalesTax
        @calculateSalesTaxDebounced
        errorField
        @resetSalesTax
        ref: f(childRefs, 'push')
      }
      RenderedSummaryComponent = if isFreeTrial
        FreeTrialSummaryComponent
      else
        SummaryComponent
      t.createElement RenderedSummaryComponent, {
        monthlyProduct: monthlyProduct
        yearlyProduct: yearlyProduct
        defaultProduct: defaultProduct
        billingStrategy: billingStrategy
        selectedBillingPlan
        subTotalCost: @calculateSubTotalCost()
        tax
        region
        invitedUsersCount: @props.invitedUsersCount
        invitedUsersSubTotal: @calculateInvitedUsersSubTotal()
      }
      t.createElement TermsOfServiceComponent, {
        errorField
        ref: f(childRefs, 'push')
      }

      t.p class: t.classify('u-form-info': true, hide: !waitingForCCAuth), ->
        t.text l(['alerts', 'authorizing'])
      t.p class: t.classify('u-form-error': true, hide: !unknownError), 'data-test-id': PurchaseFormIds.PurchaseFormSubmitError, ->
        t.text unknownError?.message ? unknownError ? ""
      t.div class: t.classify(hide: waitingForCCAuth), ->
        t.input {
          type: 'button',
          value: buttonText || t.l(buttonKey),
          'data-test-id': PurchaseFormIds.PurchaseFormSubmitButton,
          class: t.classify(
            'primary': true,
            'moonshot-billing-submit-button': isMoonshotBilling
          ),
          onClick: onClick
        }

  componentWillUnmount: ->
    @isStillMounted = false
    @_submitPromise?.cancel()

  submit: (dataPromise) ->
    if @_submitPromise?
      throw Error("Submission already in progress!")

    { onSubmit, doPoll } = @props

    @setState(errorField: null, unknownError: null, waitingForCCAuth: true)
    @_submitPromise = dataPromise
    .then (data) =>
      if data.acceptTOS? && !data.acceptTOS
        return Promise.reject CreditCardFormError.InvalidField('', field: 'acceptTOS')

      submitCreditCard f(onSubmit, data), doPoll, data
    .then (data) =>
      @props.didGetAuthStatus()
      track("Business Class", "Purchase", "#{data.products[0]}")
      return
    .catch CreditCardFormError.InvalidField, ({ field }) =>
      @setState(errorField: field)
      return
    .catch CreditCardFormError.PostError, ({ err }) =>
      if Util.isJsonString(err.message)
        errorJSON = JSON.parse(err.message)
        errorField = BillingFormUtil.getErrorField(errorJSON?.error)
        if errorField
          @setState
            errorField: errorField
      else
        @setState(unknownError: err.message ? "error")
      return
    .catch CreditCardFormError.PollError, ({ err }) =>
      @props.didntGetAuthStatus()
      return
    .catch Promise.CancellationError, (->)
    .finally =>
      if @isStillMounted
        @setState waitingForCCAuth: false
      delete @_submitPromise
      return
    .done()
